import { pipe } from '@effect/data/Function';
import * as O from '@effect/data/Option';
import * as A from '@effect/data/ReadonlyArray';
import * as Str from '@effect/data/String';
var UUID_REGEX = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
var CHANNEL_REGEX = new RegExp('/channels/channel_' + UUID_REGEX + '$');
export var parseChannelUuidFromPath = function parseChannelUuidFromPath(pathname) {
  return pipe(pathname.match(CHANNEL_REGEX), O.fromNullable, O.flatMap(A.last), O.map(Str.replace('/channels/', '')), O.getOrNull);
};
export var parseUuidFromPath = function parseUuidFromPath(pathname) {
  return parseChannelUuidFromPath(pathname);
};